import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MindDumpFlow } from '@/components/onboarding/MindDumpFlow';
import { useProfileStore } from '@/stores/profileStore';
import { useCanvasStore } from '@/stores/canvasStore';

export default function Onboarding() {
  const navigate = useNavigate();

  const handleComplete = async () => {
    // Refresh boards so the new ones appear
    await useCanvasStore.getState().fetchBoards();

    // Mark onboarding complete before navigating so Canvas.tsx renders
    // the main view (not the MindDumpFlow again)
    useProfileStore.setState({ hasCompletedOnboarding: true });

    // Try to reload profile from DB (non-blocking)
    useProfileStore.getState().loadProfile().catch(() => {});

    // Navigate to canvas (home board) so user sees all goal board folders
    navigate('/canvas', { replace: true });
  };

  return <MindDumpFlow onComplete={handleComplete} />;
}
